import React from 'react';
import { useIntl } from 'react-intl';
import css from './RenderFeaturedLocations.module.css';
import { Icons } from '../../../components';
import { localizePath } from '../../../util/canonicalUrls';

import StudioLocations from './locationImages/Studio-Locations.webp';
import UrbanLocation from './locationImages/Urban-Locations.webp';
import UniqueSpecialtyLocations from './locationImages/Unique-Specialty-Locations.webp';
import TransportationVehicleBasedSets from './locationImages/Transportation-Vehicle-Based-Sets.webp';
import SportsRecreationLocations from './locationImages/Sports-Recreation-Locations.webp';
import ResidentialLocations from './locationImages/Residential-Locations.webp';
import OutdoorNaturalLocations from './locationImages/Outdoor-Natural-Locations.webp';
import CulturalHistoricalLocations from './locationImages/Cultural-Historical-Locations.webp';

const ADDRESS = 'Thailand';
const BOUNDS = '14.30%2C101.10%2C13.20%2C99.90';
function RenderFeaturedCategories() {
  const intl = useIntl();
  const locations = [
    {
      title: intl.formatMessage({ id: 'RenderFeaturedCategories.category.studio' }),
      image: StudioLocations,
      url: `/s?address=${ADDRESS}&bounds=${BOUNDS}&pub_categoryLevel1=studio`,
    },
    {
      title: intl.formatMessage({ id: 'RenderFeaturedCategories.category.urban' }),
      image: UrbanLocation,
      url: `/s?address=${ADDRESS}&bounds=${BOUNDS}&pub_categoryLevel1=urban`,
    },
    {
      title: intl.formatMessage({ id: 'RenderFeaturedCategories.category.residential' }),
      image: ResidentialLocations,
      url: `/s?address=${ADDRESS}&bounds=${BOUNDS}&pub_categoryLevel1=residential`,
    },
    {
      title: intl.formatMessage({ id: 'RenderFeaturedCategories.category.outdoor' }),
      image: OutdoorNaturalLocations,
      url: `/s?address=${ADDRESS}&bounds=${BOUNDS}&pub_categoryLevel1=outdoor`,
    },
    {
      title: intl.formatMessage({ id: 'RenderFeaturedCategories.category.sports' }),
      image: SportsRecreationLocations,
      url: `/s?address=${ADDRESS}&bounds=${BOUNDS}&pub_categoryLevel1=sports`,
    },
    {
      title: intl.formatMessage({ id: 'RenderFeaturedCategories.category.cultural' }),
      image: CulturalHistoricalLocations,
      url: `/s?address=${ADDRESS}&bounds=${BOUNDS}&pub_categoryLevel1=cultural`,
    },
    {
      title: intl.formatMessage({ id: 'RenderFeaturedCategories.category.unique' }),
      image: UniqueSpecialtyLocations,
      url: `/s?address=${ADDRESS}&bounds=${BOUNDS}&pub_categoryLevel1=unique`,
    },
    {
      title: intl.formatMessage({ id: 'RenderFeaturedCategories.category.transport' }),
      image: TransportationVehicleBasedSets,
      url: `/s?address=${ADDRESS}&bounds=${BOUNDS}&pub_categoryLevel1=transport`,
    },
  ];

  return (
    <div className={css.sectionCategory}>
      <div className={css.fixedWidthContainer}>
        <div className={css.sectionHead}>
          <div className={css.leftSec}>
            <h2>{intl.formatMessage({ id: 'RenderFeaturedCategories.title' })}</h2>
            <p>{intl.formatMessage({ id: 'RenderFeaturedCategories.description' })}</p>

            <a
              className={css.viewAllLink}
              href={localizePath(`/s?address=${ADDRESS}&bounds=${BOUNDS}`, intl.locale)}
            >
              {intl.formatMessage({ id: 'RenderFeaturedCategories.viewAll' })}
            </a>
          </div>
        </div>

        <div className={css.categorySlider}>
          {locations.map(({ title, image, url }) => (
            <a key={title} className={css.categoryCard} href={localizePath(url, intl.locale)}>
              <div className={css.categoryCardImg}>
                <img src={image} alt={title} />
              </div>

              <div className={css.categoryCardInfo}>
                <h3>{title}</h3>
                <span>
                  <Icons name="rightAngle" />
                  {intl.formatMessage({ id: 'RenderFeaturedCategories.seeListings' })}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export default RenderFeaturedCategories;
